import React from "react";

import androidTv from "../../../resources/android_tv.png";

import type { JSX } from "react";

interface IAndroidTvIcon {
  className?: string;
}

function AndroidTvIcon(props: IAndroidTvIcon): JSX.Element {
  const { className } = props;
  return <img alt="android-tv-icon" className={className} src={androidTv} />;
}

export default AndroidTvIcon;
